import { render, staticRenderFns } from "./MyWaterfall.vue?vue&type=template&id=a90d22a6&scoped=true"
import script from "./MyWaterfall.vue?vue&type=script&lang=js"
export * from "./MyWaterfall.vue?vue&type=script&lang=js"
import style0 from "./MyWaterfall.vue?vue&type=style&index=0&id=a90d22a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90d22a6",
  null
  
)

export default component.exports